import { FC } from "react"

interface IProps {
  className?: string
}

const NavItem: FC<IProps> = ({ children, className }) => {
  return (
    <div className={"nav-item " + (className ? className : "")}>
      <button className={`ocs-btn ocs-btn-link ocs-pr-4`} onClick={() => {}}>
        {children && <span className={"ocs-btn-no-icon"}>{children}</span>}
      </button>
    </div>
  )
}

export default NavItem
